import AssignmentIcon from '@mui/icons-material/Assignment';
import LanguageIcon from '@mui/icons-material/Language';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import { ThemeProvider } from '@mui/material/styles';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import Breadcrumbs from './Breadcrumbs';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

import './index.css';

export default (element, store) => {
  const parentPageIcons = {
    '#mission-read-modal': <LanguageIcon />,
    '#project-read-modal': <LocalHospitalIcon />,
  };
  const parentPages = JSON.parse(element.dataset.parentPages).map((parentPage) => {
    return ({
      ...parentPage,
      icon: parentPageIcons[parentPage.target],
    });
  });
  const currentPage = JSON.parse(element.dataset.currentPage);
  currentPage.icon = <AssignmentIcon />;

  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <Breadcrumbs
            parentPages={parentPages}
            currentPage={currentPage}
            site={element.dataset.siteSrc}
            updatedAt={element.dataset.updatedAt}
            interventionConsultations={element.dataset.interventionConsultations ? JSON.parse(element.dataset.interventionConsultations) : []}
            cloudAccessCode={element.dataset.cloudAccessCode}
            medcaptureClientVersion={element.dataset.medcaptureClientVersion}
            parsysId={element.dataset.parsysId}
            isTestingConsultation={element.dataset.isTestingConsultation === 'True'}
          />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>,
  );

  return () => {
    root.unmount();
  };
};
